import { API } from "@/lib/api";

export default function ClientLogo({ client, className = "h-6", fallbackClass = "font-semibold truncate", testId = "client-logo" }) {
  if (!client) return null;
  if (!client.has_logo) return <span className={fallbackClass} data-testid={`${testId}-text`}>{client.name}</span>;
  return <img src={`${API}/clients/${client.id}/logo?v=${client.logo_version || ""}`} alt={client.name} className={`${className} client-logo-img w-auto object-contain object-left`} data-testid={testId} />;
}
